import React from 'react';
import withLayout from '../../components/layout/index';
import TermsAndConditions from '../../components/feature/terms-and-conditions';

const TermsConditions = () => {
    return (
        <TermsAndConditions />
    );
};

export default withLayout(TermsConditions, true, false, { search: false, wisList: false, notification: false, title: 'TERMS OF USE', back: true });
